module.exports = __webpack_public_path__ + "img/11.923d2e2e.png";